import React from "react";
import { haversineDistance } from "../../utils/distance";
import VolunteerVacancyCard, {
	type VolunteerVacancyCardProps,
} from "../SignPostCards/VolunteerVacancyCard/VolunteerVacancyCard";
import * as styles from "./VolunteerVacancyResults.module.scss";

interface Props {
	userLocation: DogsTrust.Place;
	items: VolunteerVacancyCardProps[];
}

export const VolunteerVacancyResults: React.FC<Props> = ({
	userLocation,
	items,
}) => {
	const vacanciesWithDistance = items.map((vacancy) => ({
		...vacancy,
		distance: haversineDistance(
			{
				longitude: Number.parseFloat(vacancy.vacancyLocation?.longitude),
				latitude: Number.parseFloat(vacancy.vacancyLocation?.latitude),
				address: "",
			},
			userLocation,
		),
	}));
	return (
		<div className={styles.results}>
			{vacanciesWithDistance
				.sort((a, b) => a.distance - b.distance)
				.map((vacancy) => (
					<VolunteerVacancyCard key={vacancy.volunteerRole} {...vacancy} />
				))}
		</div>
	);
};

export default VolunteerVacancyResults;
